import { useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '@yme/services/i18n';
import { getSearchParams, SearchParams } from '@yme/utils/bloomreach';
import { SearchSortingValues } from '@yme/utils/bloomreach/constants';
export const useSortFilter = ({ callback }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { sort } = getSearchParams();
    const SORTING_SEARCH_OPTIONS = [
        {
            value: SearchSortingValues.SORT_RECOMMENDED,
            label: t('productsGrid_recommended_option'),
        },
        {
            value: SearchSortingValues.SORT_ASC,
            label: t('productsGrid_oldestToNewest_option'),
        },
        {
            value: SearchSortingValues.SORT_DESC,
            label: t('productsGrid_newestToOldest_option'),
        },
        {
            value: SearchSortingValues.SORT_PRICE_ASC,
            label: t('productsGrid_priceLowToHigh_option'),
        },
        {
            value: SearchSortingValues.SORT_PRICE_DESC,
            label: t('productsGrid_priceHighToLow_option'),
        },
    ];
    const defaultSortOption = SORTING_SEARCH_OPTIONS.find((option) => option.value === sort)?.value ||
        SORTING_SEARCH_OPTIONS[0].value;
    const [sortOrder, setSortOrder] = useState(defaultSortOption);
    const handleSortOrderChange = useCallback((value) => {
        if (value !== sortOrder) {
            const queryParams = new URLSearchParams(history.location.search);
            queryParams.set(SearchParams.SORT, value);
            history.push({
                search: queryParams.toString(),
            });
        }
        setSortOrder(value);
        if (callback) {
            callback();
        }
    }, [callback, history, sortOrder]);
    useEffect(() => {
        if (sort && sort !== sortOrder) {
            setSortOrder(sort);
        }
    }, [sort, sortOrder]);
    return {
        sortingOptions: SORTING_SEARCH_OPTIONS,
        setSortOrder,
        handleSortOrderChange,
        sortOrder,
    };
};
